module.exports = __webpack_public_path__ + "img/hero-transportation.0408e8d4.jpg";